module.exports = require('./helpers/bundle-url').getBundleURL('4afSR') + "Chat.e099aff5.png";